import React from 'react';

import Tooltip from 'src/components/tooltip';
import {gpaFormat} from 'shared/utils';
import Stamp, {MARIGOLD} from 'src/components/Stamp/Stamp';
import Icon from 'shared/components/icon';

interface Props {
  minGPA: number;
  showTooltipFlag?: boolean;
}

const BoostGpaText = ({minGPA, showTooltipFlag = false}: Props) => {
  const infoText = `Boost GPA to ${gpaFormat(minGPA)} to earn`;
  if (!showTooltipFlag) {
    return (
      <Stamp color={MARIGOLD}>
        <div className="college-earnings-no-earnings-status-text-content">{infoText}</div>
      </Stamp>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp color={MARIGOLD} className="flag">
            <Icon iconType="flag" color="orange" className="tooltip-flag-icon" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};

export default BoostGpaText;
